<template>
  <div class="overview-macro">
    <div class="title">
      <div class="big-title">腾景宏观经济感知预测全口径分析系统</div>
      <div>数字时代的新宏观经济分析体系</div>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="宏观高频模拟和预测库" name="2">
        <p>
          <strong>腾景AI经济预测</strong>运用近年来快速发展的机器学习特别是深度学习等人工智能前沿技术，与实时化、动态化的投入产出体系深度融合，在一系列关键技术攻关的基础上，对重要的经济金融指标进行高频模拟和预测，形成了在国内外具有开拓性、领先性、实用性的产品体系。
        </p>
        <p>
          <strong>是什么</strong>
        </p>
        <p>
          <strong>宏观高频模拟和预测库</strong>包括“总量”“价格”“金融”领域共29个指标，是目前国家有关部门发布的反映宏观经济运行最常用也是最重要的指标。
        </p>
        <p>
          所谓
          <strong>高频模拟</strong>，就是在搜集加工大量相关数据的基础上，依托经典机器学习和深度学习模型，把月度指标日度化，使通常一个多月后才公布的指标，当日或近日就能呈现出来，比如，月初的CPI指标，过去要到一个半月后才公布，有了高频模拟，当日就知晓了。
        </p>
        <p>
          所谓
          <strong>预测</strong>，就是运用深度学习的前沿算法，重点在海量数据中搜寻非线性相关关系，发现并提炼那些过去、当下和未来都会起作用的规律性因素，从而实现对某一变量未来一定时期的预测。
        </p>
        <p>
          <strong>每个指标都包括三个部分</strong>，第一部分是历史走势，第二部分是最新走势的高频模拟，第三部分是对未来一段时间走势的预测。高频模拟是日度更新，预测依据指标特性周度或月度更新。对每个指标，既可以看到最新状态，也能看到未来一定时间（目前是9-12个月）的走势。正所谓
          <strong>近看当日，远观全年，腾景预测，一目了然。</strong>
        </p>
        <p>
          <strong>为什么</strong>
        </p>
        <p>
          <strong>特点</strong>
        </p>
        <p>
          <strong>“快”：</strong>前两天经济活动发生的变化，今天的指标上就能看到。准确地讲，已经实际发生但官方统计机构尚未发布的经济指标走势信息率先得到
        </p>
        <p>
          <strong>“远”：</strong>未来一段时间（目前是9-12月）的走势能够大体把握
        </p>
        <p>
          <strong>“全”：</strong>不是少数几个指标，反映宏观经济和金融活动走势的重要指标都包括在内
        </p>
        <p>
          <strong>“动”：</strong>所有指标都是动态更新和迭代，高频模拟是日度更新，预测是周期或月度更新
        </p>
        <p>
          <strong>“潮”：</strong>运用数字技术，展示方式别具一格，直观、绚丽、便捷，一屏观天下、知冷暖、看未来
        </p>
        <p>
          <strong>“准”：</strong>方向和数值准确率平均在70%左右，部分指标可以达到80-90%以上
        </p>
        <p>
          <strong>与众不同：我们提供了什么</strong>
        </p>
        <p>
          每一个关注和思考中国经济形势的朋友，每天实际上都在回顾过去、总结规律，看着当下、做着高频模拟，尤其是想着未来、进行着预测，只是形式不同而已。数字时代，每天各种各样的信息和说法潮水般涌来，有高见，亦不乏忽悠和杂音，一天下来，有时候不是更清醒，而是更糊涂了。
          <strong>大家所期待的，是脑海中所萦绕的那条连接历史、当下和未来的曲线能够更清晰、更有道理。我们的产品就是要满足大家的需求，给各位提供分析经济走势的干货。</strong>
        </p>
        <p>
          有朋友会问:你们的产品有什么过人之处，真的与众不同吗？这里就需要了解深度学习技术的特点和优势，还要有正确的预测观。
          <strong>与传统的计量经济模型等相比，深度学习技术运用特定算法，在强大算力加持下，在数十万、数百万乃致更多海量数据中寻找线性特别是非线性相关关系，这在传统预测方法中是不可想象的，因而在预测时间长度、精度和范围上，形成了若干个数量级的优势。</strong>
        </p>
        <p>
          当然，未来总是有不确定性的，人类社会不可能完全消除这种不确定性。反过来说，如果未来什么事情都能预测，这个世界也就无趣了。另一方面，总是有一些从过去、到现在、再到未来一直起作用，我们称之为“规律性”的因素，把握住这些因素，未来在很大程度上是有迹可循的。
          <strong>从这个意义上说，预测并不是一件神秘的事情，只是发掘那些未来仍会起作用的历史信息。</strong>
        </p>
        <p>
          也正是由于这个原因，我们多数情况下是预测某个指标的平滑值，因为平滑值含有更多的历史信息。
          <strong>预测时主要关注两个方面，一是走向，向上、向下还是平行；二是拐点，顶部的拐点或底部的拐点。对大多数指标来说，一年中最重要、最困难的是把握住一两个、两三个大的拐点，如果预测能够帮助解决这个问题，应该说足以令人满意了。</strong>
        </p>
        <p>
          我们期待的是，
          <strong>如果说您在脑海中实际上进行的高频模拟和预测准确率是60%，借助我们的产品，准确率能够提升到70%-80%乃至更高一些，通俗地说，您的成绩从60分提高到70分、80分或更高一些，从而为您的经济形势分析和具体业务活动带来实实在在的帮助。</strong>
        </p>
        <p>
          <strong>数据库预览</strong>
        </p>
        <p>
          <strong>宏观高频模拟和预测库</strong>包括“总量”“价格”“金融”共29个重要指标
        </p>
        <p class="img">
          <img src="../../assets/img/01.png" alt />
          <img src="../../assets/img/02.png" alt />
          <img src="../../assets/img/03.png" alt />
        </p>
        <p>“NSG资讯”则使您能够在有限时间内重点关注那些对GDP走势影响较大的正向和负向两方面信息</p>
        <p class="img">
          <img src="../../assets/img/04.png" alt />
        </p>
        <p>
          <strong>对谁有用</strong>
        </p>
        <p>
          <strong>对所有关心中国经济走势、对中国经济社会发展感兴趣的人士都有用。</strong>重点是
          <strong>
            各级政府官员、特别是主管经济事务的官员，
            大中小各类企业的经营管理者，
            银行、证券、保险、资管等各类金融机构的从业者，
            研究中国经济的科研人员，
            报道中国经济形势的媒体记者，
          </strong>等等。
        </p>
        <p>
          <strong>我们特别推荐各级政府、各个企业、各个经济科研单位和各个经济传媒机构负责人，都应带头使用宏观高频模拟和预测库，</strong>每天抽出三五分钟时间，看一下重要指标的最新动态和未来走势，放眼全局，心中有数，工作起来将会更加自信从容。
        </p>
        <p>
          <strong>宏观高频模拟和预测库是每一个关注中国经济走势人士的“标配产品”</strong>
        </p>
      </el-tab-pane>
      <el-tab-pane label="行业高频模拟和预测库" name="3">
        <p>
          <strong>腾景AI经济预测</strong>运用近年来快速发展的机器学习特别是深度学习等人工智能前沿技术，与实时化、动态化的投入产出体系深度融合，在一系列关键技术攻关的基础上，对重要的经济金融指标进行高频模拟和预测，形成了在国内外具有开拓性、领先性、实用性的产品体系。
        </p>
        <p>
          <strong>是什么</strong>
        </p>
        <p>
          <strong>行业高频模拟和预测库</strong>包括工业36个指标，服务业30个指标，农业和建筑业各1个指标，是按照国家统计部门的标准分类，在动态投入产出MDEMS系统形成的全口径数据基础上构建。
        </p>
        <p>
          所谓
          <strong>高频模拟</strong>，就是在搜集加工大量相关数据的基础上，依托经典机器学习和深度学习模型，把月度指标日度化，使通常一个多月后才公布的指标，当日或近日就能呈现出来，比如，月初的CPI指标，过去要到一个半月后才公布，有了高频模拟，当日就知晓了。
        </p>
        <p>
          所谓
          <strong>预测</strong>，就是运用深度学习的前沿算法，重点在海量数据中搜寻非线性相关关系，发现并提炼那些过去、当下和未来都会起作用的规律性因素，从而实现对某一变量未来一定时期的预测。
        </p>
        <p>
          <strong>每个指标都包括三个部分</strong>，第一部分是历史走势，第二部分是最新走势的高频模拟，第三部分是对未来一段时间走势的预测。高频模拟是日度更新，预测是月度更新。对每个指标，既可以看到最新状态，也能看到未来一定时间（目前是9-12个月）的走势。正所谓近看当日，远观全年，腾景预测，一目了然。
        </p>
        <p>
          <strong>为什么</strong>
        </p>
        <p>
          <strong>特点</strong>
        </p>
        <p>
          <strong>“快”：</strong>前两天经济活动发生的变化，今天的指标上就能看到。准确地讲，已经实际发生但官方统计机构尚未发布的经济指标走势信息率先得到
        </p>
        <p>
          <strong>“远”：</strong>未来一段时间（目前是9-12月）的走势能够大体把握
        </p>
        <p>
          <strong>“全”：</strong>反映工业、服务业、农业和建筑业增长走势的重要指标都包括在内，尤其是服务业各行业的月度指标，官方统计中并不提供，由我们依托全口径数据体系加高频数据研制而成
        </p>
        <p>
          <strong>“动”：</strong>所有指标都是动态更新和迭代，高频模拟是日度更新，预测是月度更新
        </p>
        <p>
          <strong>“潮”：</strong>运用数字技术，展示方式别具一格，直观、绚丽、便捷，一屏观天下、知冷暖、看未来
        </p>
        <p>
          <strong>“准”：</strong>方向和数值准确率平均在70%左右，部分指标可以达到80-90%以上
        </p>
        <p>
          <strong>与众不同：我们提供了什么</strong>
        </p>
        <p>
          每一个关注和思考中国经济形势的朋友，每天实际上都在回顾过去、总结规律，看着当下、做高频模拟，尤其是想着未来、进行着预测，只是形式不同而已。数字时代，各种各样的信息和说法潮水般涌来，有高见，亦不乏忽悠和杂音，一天下来，有时候不是更清醒，而是更糊涂了。
          <strong>大家所期待的，是脑海中所萦绕的那条连接历史、当下和未来的曲线能够更清晰、更有道理。我们的产品就是要满足大家的需求，给各位提供分析行业走势的干货。</strong>
        </p>
        <p>
          有朋友会问:你们的产品有什么过人之处，真的与众不同吗？这里就需要了解深度学习技术的特点和优势，还要有正确的预测观（参见“问答”栏目有关条目）。
          <strong>与传统的计量经济模型等相比，深度学习技术运用特定算法，在强大算力加持下，在数十万、数百万乃致更多海量数据中寻找线性特别是非线性相关关系，这在传统预测方法中是不可想象的，因而在预测时间长度、精度和范围上，形成了若干个数量级的优势。</strong>
        </p>
        <p>
          当然，未来总是有不确定性的，人类社会不可能完全消除这种不确定性。反过来说，如果未来什么事情都能预测，这个世界也就无趣了。另一方面，总是有一些从过去、到现在、再到未来一直起作用，我们称之为“规律性”的因素，把握住这些因素，未来在很大程度上是有迹可循的。
          <strong>从这个意义上说，预测并不是一件神秘的事情，只是发掘那些未来仍会起作用的历史信息。</strong>
        </p>
        <p>
          也正是由于这个原因，我们多数情况下是预测某个指标的平滑值，因为平滑值含有更多的历史信息。
          <strong>预测时主要关注两个方面，一是走向，向上、向下还是平行；二是拐点，顶部的拐点或底部的拐点。对大多数指标来说，一年中最重要、最困难的是把握住一两个、两三个大的拐点，如果预测能够帮助解决这个问题，应该说足以令人满意了。</strong>
        </p>
        <p>
          我们期待的是，
          <strong>如果说您在脑海中实际上进行的高频模拟和预测准确率是60%，借助我们的产品，准确率能够提升到70%-80%乃至更高一些，通俗地说，您的成绩从60分提高到70分、80分或更高一些，从而为您的经济形势分析和具体业务活动带来实实在在的帮助。</strong>
        </p>
        <p>
          <strong>数据库预览</strong>
        </p>
        <p>
          <strong>行业高频模拟和预测库</strong>包括工业36个指标、服务业30个指标、农业和建筑业各1个指标，在动态投入产出MDEMS系统形成的全口径数据基础上构建。
        </p>
        <p class="img">
          <img src="../../assets/img/05.png" alt />
        </p>
        <p>
          <strong>对谁有用</strong>
        </p>
        <p>
          <strong>对所有关心中国经济尤其是行业增长走势的人士都有用</strong>。重点是
          <strong>
            各级政府官员、特别是主管行业发展事务的官员，
            相关行业大中小各类企业的经营管理者，
            银行、证券、保险、资管等各类金融机构的从业者，
            研究中国经济的科研人员，
            报道中国经济和行业走势的媒体记者，
          </strong>等等。
        </p>
        <p>
          <strong>我们特别推荐各级政府行业主管部门负责人、相关行业各个企业的老板们，都应带头使用行业高频模拟和预测库，</strong>每天抽出三五分钟时间，看一下重要指标的最新动态和未来走势，放眼全局，心中有数，工作起来将会更加自信从容。
        </p>
        <p>
          <strong>行业高频模拟和预测库是每一个关注中国经济尤其是行业走势人士的“标配产品”</strong>
        </p>
      </el-tab-pane>
      <el-tab-pane label="宏观和行业全口径数据" name="4">
        <p>
          <strong>腾景AI经济预测</strong>运用近年来快速发展的机器学习特别是深度学习等人工智能前沿技术，与实时化、动态化的投入产出体系深度融合，在一系列关键技术攻关的基础上，对重要的经济金融指标进行高频模拟和预测，形成了在国内外具有开拓性、领先性、实用性的产品体系。
        </p>
        <p>
          <strong>是什么</strong>
        </p>
        <p>
          <strong>宏观和行业全口径数据库</strong>是我们研究团队对投入产出体系动态化、实时化改造而构建的具有创新性、复杂性和实用性的新型数据体系。投入产出表最初由美国经济学家、诺奖获得者列昂惕夫提出，是迄今为止反映宏观经济和行业关联关系最为完整的方法体系。我们在研发并验证一系列转换矩阵表的基础上，在投入产出体系的需求侧和生产侧之间建立起高度复杂的高频关联关系 ，形成了“多维动态均衡矩阵系统（MDEMS）”。这是一项难度很大、国内外此前尚无人做过的基础性研究工作。
        </p>
        <p>
          <strong>为什么</strong>
        </p>
        <p>
          <strong>特点</strong>
        </p>
        <p>
          <strong>全口径数据：</strong>官方每月发布的数据，大部分属于片段性数据，比如社会消费品零售总额，反映的只是部分商品消费，还不包括服务消费；固定资产投资完成额也没有剔除土地使用费等，与构成GDP的固定资本形成差距较大。另外，目前的月度官方统计中，还不能提供大部分服务业的增长数据。而我们的全口径数据体系中，提供了需求侧（支出法）和供给侧（生产法）各个部分的全口径月度数据，包括全部服务业增长的月度数据。
        </p>
        <p>
          <strong>全方位装配：</strong>各类经济数据，不论来自何方，宏观的、行业的、区域的、企业的，都能在这一体系中找到一个合适位置，相互关联、相互推导、相互印证，使各类数据能够真正发挥它们的作用。
        </p>
        <p>
          <strong>全面反映联系：</strong>全面反映并显示各类数据之间的联系和关系。数据库中“结构”板块展示了需求侧和供给侧不同层面的比例关系，其中的“增量”结构直观了反映经济增长新动能；“拉动”板块体现了经济体系中不同部分之间复杂的相互带动关系，比如疫情期间服务业下滑对全社会增加值的影响，出口增加对计算机、通信和其他电子设备制造业增长的影响等，都可具体得以展现。“关联”栏目则全面显示了具体行业上下游的投入产出图谱，如黑色金属冶炼及压延加工业的上游和下游各有哪些行业，相关部分由现价和不变价计算的规模和比重各是多少，都能一目了然。
        </p>
        <p>
          <strong>数据库预览</strong>
        </p>
        <p>
          <strong>宏观和行业全口径数据库</strong>包括了宏观方面的国民经济核算、价格、利润、资本存量、劳动力、产能利用率和行业方面的农业、工业、服务业、建筑业的全口径数据。在这个板块，各位会看到熟悉的数据库格式，可根据需要对这些指标数据进行查询、展示、比较和分析。
        </p>
        <p class="img">
          <img src="../../assets/img/06.png" alt />
        </p>
        <p>
          <strong>“结构、拉动、关联”板块</strong>中，“结构”栏目展示了需求侧和供给侧不同层面的比例关系，其中很值得关注的是总需求“增量”中各部分需求的比重，总产出“增量”中各行业的比重，它们直观地反映了大家平时很关注的经济增长新动能。
        </p>
        <p class="img">
          <img src="../../assets/img/07.png" alt />
        </p>
        <p>
          <strong>对谁有用</strong>
        </p>
        <p>
          <strong>对深耕中国宏观经济和行业发展研究的专业研究机构和人士都有用</strong>。重点是
          <strong>
            政府综合性经济事务主管机构和较高水准的研究型智库，
            大型企业的战略研究部门，中小企业对深度经济研究感兴趣者，
            银行、证券、保险、资管等各类金融机构，
            深度研究中国经济的专业科研人员
          </strong>，等等。
        </p>
        <p>
          <strong>宏观和行业全口径数据库是每一个志在高质量研究中国经济的机构和人士的“专属产品”</strong>
        </p>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "2"
    };
  },
  created() {
    // if (this.$route.query.id) {
    //   this.activeName = this.$route.query.id;
    // }
  }
};
</script>

<style lang="scss" scoped>
.overview-macro {
  background: #fff;
  margin: 20px 0 0 20px;
  padding: 20px;
  box-sizing: border-box;
  .title {
    color: #333399;
    text-align: center;
    font-size: 24px;
    padding: 30px 0;
    .big-title {
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 2px;
    }
  }
  p {
    text-indent: 32px;
    img {
      height: 300px;
      padding-bottom: 20px;
    }
    &.img {
      text-align: center;
    }
  }
  /deep/ .el-tabs .el-tabs__item {
    padding-left: 0 !important;
    padding-bottom: 14px !important;
    height: 42px !important;
    padding-right: 48px !important;
    font-size: 16px !important;
  }
}
</style>